export const WChartProperties: any = {
  yAxis: [
    { // Observations chart.
      opposite: false,
      labels: {
        align: 'right',
        x: -3,
        format: '{value}',
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Velocity (m/s)',
      },
      height: '80%',
      lineColor: '#ccd6eb',
      lineWidth: 2,
      resize: {
        enabled: true,
      },
    },
    { // Checks chart.
      labels: {
        enabled: false,
        align: 'right',
        x: -3,
        formatter() {
          return this.value + 'm';
        },
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Checks',
      },
      top: '85%',
      height: '15%',
      offset: 0,
      lineWidth: 2,
      lineColor: '#ccd6eb',
    },
    { // Observations chart right.
      opposite: true,
      showEmpty: false,
      labels: {
        align: 'right',
        x: -3,
        format: '{value} ',
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Degrees',
      },
      height: '80%',
      lineWidth: 2,
      lineColor: '#ccd6eb',
      resize: {
        enabled: true,
      },
      offset: 0,
      floating: true,
    },
    { // Observations chart right.
      opposite: true,
      showEmpty: false,
      labels: {
        align: 'right',
        x: -3,
        format: '{value} ',
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Gust (m/s)',
      },
      height: '80%',
      lineWidth: 2,
      lineColor: '#ccd6eb',
      resize: {
        enabled: true,
      },
      floating: true,
    },
    { // Observations chart right.
      opposite: true,
      showEmpty: false,
      labels: {
        align: 'right',
        x: -3,
        format: '{value} ',
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Backing (degrees)',
      },
      height: '80%',
      lineWidth: 2,
      lineColor: '#ccd6eb',
      resize: {
        enabled: true,
      },
      floating: true,
    },
    { // Observations chart right.
      opposite: true,
      showEmpty: false,
      labels: {
        align: 'right',
        x: -3,
        format: '{value} ',
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Veering (degrees)',
      },
      height: '80%',
      lineWidth: 2,
      lineColor: '#ccd6eb',
      resize: {
        enabled: true,
      },
      floating: true,
    },
  ],
};
